import { render } from "./BenefitList.vue?vue&type=template&id=29f0781a&scoped=true"
import script from "./BenefitList.vue?vue&type=script&lang=js"
export * from "./BenefitList.vue?vue&type=script&lang=js"

import "./BenefitList.vue?vue&type=style&index=0&id=29f0781a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f0781a"]])

export default __exports__